// 生产环境
module.exports = {
    NODE_ENV: '"production"',
    hosturl:'http://101.201.181.152:80',
    // hosturl:'http://101.201.181.152:7321',
    //downloadurl:'http://47.97.5.38:8000/',
    downloadurl:'http://101.201.181.152:8000/',
    blasturl:"http://101.201.181.152"
}
